'use client'
import { useTranslations } from '@/lib/next-shim'

import { DocumentsSection } from '@/features/documents'
import { NoSSR } from '@/shared/ui/NoSSR'
import { PageTitle } from '@/shared/ui/seo/PageTitle'

import { useDashboard } from '../model/useDashboard'
import { Consultations } from './Consultations'
import { DashboardHeader } from './DashboardHeader'
import { DashboardSkeleton } from './DashboardSkeleton'
import { DefaultMeetingLinks } from './DefaultMeetingLinks'
import { Expertises } from './Expertises'
import { Orders } from './Orders'
import { ProfileCompletionBanner } from './ProfileCompletionBanner'

export function DashboardPage() {
  return (
    <>
      <PageTitle title="Dashboard" />
      <NoSSR fallback={<DashboardSkeleton />}>
        <Dashboard />
      </NoSSR>
    </>
  )
}

function Dashboard() {
  const t = useTranslations('page.AccountDashboard')
  const { consultations, expertises, files, firstName, orders, patientId } = useDashboard()

  return (
    <div className="flex flex-1 flex-col w-full">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 pt-6 pb-20 sm:gap-10">
        <DashboardHeader firstName={firstName} consultationsCount={consultations.length} ordersCount={orders.length} documentsCount={files.length} />
        <ProfileCompletionBanner />
        <DefaultMeetingLinks />
        <Orders orders={orders} />
        <Consultations consultations={consultations} />
        <Expertises expertises={expertises} />
        <DocumentsSection files={files} title={t('documents.title')} showUploadButton objectType="patient" objectId={patientId} />
      </div>
    </div>
  )
}
